// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"206":"d485075c","840":"b17c322a"}[chunkId] + ".css";
};